interface ConfigurationSectionProps {
  pathogen: string;
  onPathogenChange: (value: string) => void;
  deviceId: string;
  onDeviceIdChange: (value: string) => void;
  electrodeType: string;
  onElectrodeTypeChange: (value: string) => void;
}

const PATHOGEN_OPTIONS = [
  { value: 'FLU_A', label: 'Influenza A' },
  { value: 'FLU_B', label: 'Influenza B' },
  { value: 'RSV', label: 'RSV' },
  { value: 'SARS_COV2', label: 'COVID-19' }
];

const ELECTRODE_OPTIONS = [
  { value: 'WP20_4CH', label: 'WP20 4-Channel' },
  { value: 'WP20_1CH', label: 'WP20 1-Channel' },
  { value: 'LEGACY', label: 'Legacy' }
];

export function ConfigurationSection({
  pathogen,
  onPathogenChange,
  deviceId,
  onDeviceIdChange,
  electrodeType,
  onElectrodeTypeChange
}: ConfigurationSectionProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 border border-gray-200 dark:border-gray-700">
      {/* Section Header */}
      <div className="flex items-center gap-2 mb-6">
        <span className="text-2xl">⚙️</span>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          Pipeline Configuration
        </h3>
      </div>

      {/* Configuration Fields */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Pathogen Type */}
        <div>
          <label className="block text-sm font-semibold text-gray-900 dark:text-white mb-2">
            Pathogen Type <span className="text-red-500">*</span>
          </label>
          <select
            value={pathogen}
            onChange={(e) => onPathogenChange(e.target.value)}
            aria-label="Select pathogen type"
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 transition-colors hover:border-blue-400 focus:border-blue-500 focus:outline-none"
          >
            {PATHOGEN_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {/* Device ID */}
        <div>
          <label className="block text-sm font-semibold text-gray-900 dark:text-white mb-2">
            Device ID <span className="text-gray-500 text-xs">(optional)</span>
          </label>
          <input
            type="text"
            value={deviceId}
            onChange={(e) => onDeviceIdChange(e.target.value)}
            placeholder="e.g., TEST_DEVICE_001"
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 text-sm transition-colors hover:border-blue-400 focus:border-blue-500 focus:outline-none"
          />
        </div>

        {/* Electrode Type */}
        <div>
          <label className="block text-sm font-semibold text-gray-900 dark:text-white mb-2">
            Electrode Type <span className="text-red-500">*</span>
          </label>
          <select
            value={electrodeType}
            onChange={(e) => onElectrodeTypeChange(e.target.value)}
            aria-label="Select electrode type"
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 transition-colors hover:border-blue-400 focus:border-blue-500 focus:outline-none"
          >
            {ELECTRODE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Help Text */}
      <p className="text-xs text-gray-600 dark:text-gray-400 mt-4">
        <span className="text-red-500">*</span> Required fields
      </p>
    </div>
  );
}
